import { ApolloLink, HttpLink, ApolloClient } from '@apollo/client'
import { InMemoryCache } from '@apollo/client/cache'
import { createPersistedQueryLink } from '@apollo/client/link/persisted-queries'
import { sha256 } from 'js-sha256'
import config from 'config'
import { isClient, isE2EMode } from '../../utils'
import getSessionLink from './links/session'
import getCookieLink from './links/cookie'
import getLogLink from './links/log'
import getLoginRedirectLink from './links/loginRedirect'
import fetchFn from '../fetch'

function getNewClient(options) {
  return new ApolloClient({
    ...options,
    ssrMode: !isClient(),
    connectToDevTools: config.env !== 'production'
  })
}

function getNewCache({ state }) {
  const cache = new InMemoryCache()

  if (state) {
    cache.restore(state)
  }

  return cache
}

function getApolloClient(cookies, options) {
  const { headers } = options
  const cache = getNewCache(options)
  const basicLinkList = [
    getSessionLink(cookies, options),
    getCookieLink(options),
    getLogLink(cookies),
    getLoginRedirectLink(cookies, options)
  ]

  const link = ApolloLink.from([
    ...(isE2EMode() ? [] : basicLinkList), // avoid additional Apollo links side effects @sinslav
    new HttpLink({
      uri: options.uri,
      credentials: 'same-origin',
      headers,
      fetch: fetchFn
    })
  ])

  return getNewClient({
    link: options.apq ? createPersistedQueryLink({useGETForHashedQueries: true, sha256}).concat(link) : link,
    cache
  })
}

export { getNewClient, getNewCache, getApolloClient }
